import { useState, useContext, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import MDInput from "components/MDInput";
import FormField from "components/FormField";
import { DataContext } from "context/dataContext";
import ErrorText from "components/ErrorText";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Autocomplete } from "@mui/material";
import { v4 as uuidv4 } from "uuid";

const AddQuoteForm = ({ showAsPopup }) => {
  const params = useParams();

  const { dataState, createQuoteApi } = useContext(DataContext);
  const navigate = useNavigate();

  const [value, setValue] = useState({
    quote: "",
    author: "",
  });

  const [errors, setErrors] = useState({
    quote: "",
    author: "",
  });

  const uuidvNumbers = () => {
    const uuid = uuidv4();
    const uuidFinal = uuid.replace(/\D/g, "").slice(0, 12);
    return Number(uuidFinal);
  };

  const validateForm = () => {
    const newErrors = {
      quote: value.quote ? "" : "Quote is required",
      author: value.author ? "" : "Author is required",
    };

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  const handleQuote = (e) => {
    setValue({ ...value, quote: e.target.value });
  };

  const handleAuthor = (e) => {
    setValue({ ...value, author: e.target.value });
  };

  const ResetValue = () => {
    setValue({ ...value, quote: "" });
    setValue({ ...value, author: "" });
  };

  const handleSubmit = (e) => {
    console.log("value", value);
    e.preventDefault();

    if (validateForm()) {
      var quote_id = uuidvNumbers();

      createQuoteApi({
        id: quote_id,
        quote: value.quote,
        author: value.author,
        created_on: new Date(),
      }).then((res) => {
        if (res.success) {
          if (showAsPopup) {
            showAsPopup(false);
            console.log("Quote added");
            //window.location.refresh(false);
          }
          ResetValue();
        } else {
          console.log("Something went wrong");
        }
      });
    }
  };

  return (
    <Card autoComplete="off" sx={{ height: "100%", ...(showAsPopup && { boxShadow: "none" }) }}>
      <MDBox p={3} pb={0}>
        <MDTypography variant="h5">Add a New Quote</MDTypography>
      </MDBox>
      <MDBox p={3}>
        <MDBox component="form" pb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={showAsPopup ? 12 : 3}>
              <FormField
                type="text"
                multiline
                rows={3}
                value={value.quote}
                onChange={handleQuote}
                label="Quote"
              />
              {errors.quote && <ErrorText errorName={errors.quote} />}
            </Grid>
            <Grid item xs={12} sm={showAsPopup ? 12 : 3}>
              <FormField type="text" label="Author" value={value.author} onChange={handleAuthor} />
              {errors.author && <ErrorText errorName={errors.author} />}
            </Grid>
          </Grid>
        </MDBox>

        <MDBox mt={2} gap={2} width="100%" display="flex" justifyContent="flex-start">
          <MDButton variant="gradient" color="primary" onClick={handleSubmit}>
            Save Quote
          </MDButton>
        </MDBox>
      </MDBox>
    </Card>
  );
};

export default AddQuoteForm;
